module.exports = __webpack_public_path__ + "img/coxa-media-d.b27a2a1a.png";